module.exports = __webpack_public_path__ + "static/media/Prologue Map.f49e457d.png";